import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const FOLLOW_UP: AppRouteRecordRaw = {
  path: '/follow-up-management',
  name: 'FollowUpManagement',
  component: DEFAULT_LAYOUT,
  // redirect: '/follow-up-management/today',
  meta: {
    locale: 'menu.followUpManagement',
    requiresAuth: true,
    icon: 'icon-thunderbolt',
    order: 2,
    // 隐藏「回访管理」整个菜单（含子菜单），路由本身仍可通过 URL 访问
    // 注：父级有可见子节点时，菜单树构建器会跳过父级 hideInMenu 判断，
    // 必须同时 hideChildrenInMenu 使其进入叶子分支，hideInMenu 才能生效
    hideInMenu: true,
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'today',
      name: 'Today',
      component: () => import('@/views/follow-up/today/index.vue'),
      meta: {
        locale: 'menu.todayFollowUp',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'expired',
      name: 'Expired',
      component: () => import('@/views/follow-up/expired/index.vue'),
      meta: {
        locale: 'menu.expiredFollowUp',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'records',
      name: 'FollowUpHistory',
      component: () => import('@/views/follow-up/records/records.vue'),
      meta: {
        locale: 'menu.followUpHistory',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default FOLLOW_UP;
